import { EdgeResizer } from '~src/utils/EdgeResizer';
import { triggerStateChangedRequest } from '~core';
import { trackEvent } from '~src/tracking';
import { changeImageSrc } from '~src/utils/changeImageSrc';
import Swal from 'sweetalert2';

export async function applyResizeImage(
  imageObject,
  newWidth,
  newHeight,
  quality
) {
  Swal.fire({
    title: 'Riduzione in corso...',
    text: 'Attendere prego',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  try {
    const originalSrc = imageObject.getSrc();
    const edgeResizer = new EdgeResizer(originalSrc);

    // Add quality parameter
    edgeResizer.params.set('q', quality);

    // Resize the image
    const newImageUrl = edgeResizer.resize(newWidth, newHeight, 'contain');

    // Update the image object using changeImageSrc
    await changeImageSrc(imageObject, newImageUrl);

    window.canvas.renderAll();
    triggerStateChangedRequest();

    Swal.close();

    trackEvent('Resize Image', {
      originalWidth: Math.round(imageObject.width),
      originalHeight: Math.round(imageObject.height),
      newWidth: newWidth,
      newHeight: newHeight,
      quality: quality,
    });
  } catch (error) {
    console.error('Error resizing image:', error);
    Swal.close();
    Swal.fire({
      icon: 'error',
      title: 'Errore',
      text:
        "Si è verificato un errore durante il ridimensionamento dell'immagine",
      confirmButtonColor: '#278e8e',
    });
  }
}
